export const apiCreate = (): string => '/users/salesTables/'
export const apiList = (id?: string): string =>
  !id ? '/users/salesTables/' : `/users/salesTables/view/${id}`
export const apiUpdate = (id: string): string =>
  `/users/salesTables/update/${id}`
export const apiDelete = (id: string): string => `/users/salesTables/${id}`
